import Axios from "axios";
import config from "@/config/config";
import { getUserToken, getGuest, getBasket, getDevice } from "@/utils/auth";
import { Toast } from "vant";

/**
 * @description axios请求封装
 */
let axiosInstance = Axios.create({
    baseURL: config.API_BASE_URL,
    timeout: config.API_NORMAL_TIMEOUT,
    responseType: "json",
});

/**
 * @description 请求前的拦截
 */
axiosInstance.interceptors.request.use(
    function(config) {
        let param = {
            token: getUserToken(),
            basketId: getBasket(),
            guestId: getGuest(),
            deviceId: getDevice(),
            browserInfo: "",
        };
        config.headers["ygw_header_param_web"] = JSON.stringify(param);
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

/**
 * @description 响应的拦截
 */
axiosInstance.interceptors.response.use(
    function(response) {
        const res = response.data;
        let { code = 0 } = res;
        //成功处理
        if (code == config.API_SUCCESS_CODE) {
            return Promise.resolve(res);
        } else {
            //重定向
            if (
                code == config.API_NOT_PERMISSION_CODE ||
                code == config.API_OCCUPATION_CODE
            ) {
                window.location.href = `/account/login/password`;
                return;
            } else if (code == config.API_ERROR_COLDE) {
                Toast(res.msg);
            }
            return Promise.reject(res);
        }
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default axiosInstance;
